export enum BeeswaxReportProperties {
  DAY = 'Day',
  WEEK = 'Week',
  MONTH = 'Month',
  QUARTER = 'Quarter',
  PLATFORM_DEVICE_TYPE = 'Platform Device Type',
  IMPRESSIONS = 'Impressions',
  VCR = 'Video Complete Percent',
  CTR = 'CTR',
  LTR = 'Audio Complete Percent',
  CLICKS = 'Clicks',
  VIDEO_COMPLETES = 'Video Completes',
  VIDEO_PLAYS = 'Video Plays',
  VIDEO_DURATION = 'Video Duration',
  DEVICE_TYPE = 'Device Type', // mapped, doesn't exist on default beeswax report
  CAMPAIGN_NAME = 'Campaign Name',
  CAMPAIGN_ID = 'Campaign ID',
  CREATIVE_NAME = 'Creative Name',
  LINE_ITEM_NAME = 'Line Item Name',
  SEGMENT_NAME = 'Segment Name',
  IP_REACH = 'Reach (IP-Based)',
  IP_FREQUENCY = 'Frequency (IP-Based)',
  FREEWHEEL_REACH = 'Reach (Freewheel Household ID)',
  FREEWHEEL_FREQUENCY = 'Frequency (Freewheel Household ID)',
  HOUR_OF_DAY = 'Hour of Day',
  DAYPART = 'Daypart', // mapped, doesn't exist on default beeswax report
  DEAL_ID = 'Deal ID',
  DEALS = 'Deals', // mapped, doesn't exist on default beeswax report
  ENVIRONMENT_TYPE = 'Environment Type',
  DIGITAL_CHANNEL = 'Digital Channel', // mapped, doesn't exist on default beeswax report
  PLACEMENT_TYPE = 'Placement Type',
  PUBLISHER_NAME = 'Publisher Name',
  DOMAIN = 'Domain',
  APP_BUNDLE = 'App Bundle',
  APP_NAME = 'App Name',
  IP_CONVERSIONS = 'Conversions',
  IP_CONVERSION_PERCENT = 'Conversion Percent', // mapped, doesn't exist on default beeswax report
  REACH = 'Reach',
  FREQUENCY = 'Frequency',
  CPM_USD = 'CPM USD',
  SPEND = 'Spend', // mapped, doesn't exist on default beeswax report
  DATA_FEES = 'Data Fees', // mapped, doesn't exist on default beeswax report
  TOTAL_SPEND = 'Total Spend', // mapped, doesn't exist on default beeswax report
  GEO_ZIP = 'Geo Zip',
  // Simplifi Zip+4 scale (addressable geofencing). Must match the BE's
  // SimplifiReportProperty.GEO_ZIP_4 string so grid rows read the field.
  GEO_ZIP_4 = 'Geo Zip+4',
  GEO_COUNTY = 'Geo County',
  GEO_COUNTY_ID = 'countyId', // mapped, used for map boundaries
  GEO_CONGRESSIONAL_DISTRICTS = 'Geo Congressional Districts',
  GEO_FENCE = 'Geo Fence',
  GEO_STATE = 'Region/State',
  ADVERTISER_NAME = 'Advertiser Name',
  ADVERTISER = 'Advertiser',
  ADVERTISER_ID = 'Advertiser ID',
  CONTENT_NETWORK_NAME = 'Content Network Name',
  CONTENT_CHANNEL_NAME = 'Content Channel Name',
  NAME = 'Name',
  DISTRIBUTION = 'Distribution', // mapped
  DAY_OF_WEEK = 'Day Of Week', // mapped
  DMA_CODE = 'Metro/DMA Code',
  CITY = 'City',
  CITY_CODE = 'City Code',
  DMA_NAME = 'Metro/DMA',
  EVENT_TAG_FIRE_COUNT = 'Event Tag Fire Count',
  APP = 'App',
  //#region PACING
  ACTIVE = 'Active',
  CAMPAIGN_OSI = 'Campaign OSI',
  CAMPAIGN_BUDGET = 'Campaign Budget',
  CAMPAIGN_START_DATE = 'Campaign Start Date',
  CAMPAIGN_END_DATE = 'Campaign End Date',
  CAMPAIGN_IMPRESSIONS = 'Campaign Impressions',
  CAMPAIGN_IMPRESSIONS_YESTERDAY = 'Campaign Impressions Yesterday',
  CAMPAIGN_IMPRESSIONS_THROUGH_YESTERDAY = 'Campaign Impressions Through Yesterday',
  LINE_ITEM_ID = 'Line Item ID',
  LINE_ITEM_ALTERNATIVE_ID = 'Line Item Alternative ID',
  LINE_ITEM_START_DATE = 'Line Item Start Date',
  LINE_ITEM_BUDGET = 'Line Item Budget',
  LINE_ITEM_END_DATE = 'Line Item End Date',
  LINE_ITEM_IMPRESSIONS = 'Line Item Impressions',
  LINE_ITEM_OSI = 'Line Item OSI',
  LINE_ITEM_IMPRESSIONS_YESTERDAY = 'Line Item Impressions Yesterday',
  LINE_ITEM_IMPRESSIONS_THROUGH_YESTERDAY = 'Line Item Impressions Through Yesterday',
  FLIGHT_ID = 'Flight ID',
  FLIGHT_NAME = 'Flight Name',
  FLIGHT_START_DATE = 'Flight Start Date',
  FLIGHT_BUDGET = 'Flight Budget',
  FLIGHT_END_DATE = 'Flight End Date',
  FLIGHT_IMPRESSIONS = 'Flight Impressions',
  FLIGHT_OSI = 'Line Item Flight OSI',
  FLIGHT_IMPRESSIONS_YESTERDAY = 'Flight Impressions Yesterday',
  FLIGHT_IMPRESSIONS_THROUGH_YESTERDAY = 'Flight Impressions Through Yesterday',
  EVENT_NAME = 'Event Name',
  EVENT_ID = 'Event ID',
  LOGO = 'Logo',
  CLIENT_SPEND = 'Client Spend',
  CLIENT_SPEND_CPA = 'Client Spend CPA',
  TOTAL_SPEND_CPA = 'Total Spend CPA',
  //#region foot traffic
  FOOT_TRAFFIC_VISITS = 'Foot Traffic Visits',
  FT_OMNICHANNEL_IMPRESSIONS = 'Omnichannel Impressions',
  FT_YOUTUBE_IMPRESSIONS = 'YouTube Impressions',
  FT_AUDIO_IMPRESSIONS = 'Audio Impressions',
  VISITS_CONVERSION_RATE = 'Visits Conversion Rate',
  LIFT_PERCENT = 'Lift %',
  ON_AIR_AVG_WEEKLY_VISITS = 'On-Air Avg Weekly Visits',
  OFF_AIR_AVG_WEEKLY_VISITS = 'Off-Air Avg Weekly Visits',
  //#endregion
  GENRE = 'Genre',
  //#region search
  COST_PER_CLICK = 'Cost Per Click (CPC)',
  COST_PER_IMPRESSION = 'Cost Per Impression (CPM)',
  COST_PER_CONVERSION = 'Cost Per Conversion',
  PUBLISHER_PLATFORM = 'Publisher Platform',
  AD_GROUP = 'Ad Group',
  KEYWORD = 'Keyword',
  PLATFORM = 'Platform',
  AGENCY_NAME = 'Agency Name',
  AD_NAME = 'Ad Name',
  ENGAGEMENTS = 'Engagements',
  ENGAGEMENT_RATE = 'Engagement Rate',
  //#endregion
  //#region simplifi geo-fence attribution
  // Values match Simplifi's `SimplifiReportProperty` enum on the BE.
  CONVERSION_FENCE = 'Conversion Fence',
  TOTAL_VISITS = 'Total Visits',
  //#endregion
}

export default BeeswaxReportProperties;
